import React from 'react';
import './style.css';

const AdminConfirmModal = ({ isOpen, title, message, onCancel, onConfirm, confirmLabel = 'Supprimer' }) => {
  React.useEffect(() => {
    if (!isOpen) return undefined;
    const closeOnEscape = (event) => { if (event.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="admin-confirm-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onCancel(); }}>
      <div className="admin-confirm-modal" role="dialog" aria-modal="true" aria-labelledby="admin-confirm-title">
        <div className="admin-confirm-icon"><i className="fa fa-trash-o" aria-hidden="true" /></div>
        <h2 id="admin-confirm-title">{title || 'Confirmer la suppression'}</h2>
        <p>{message || 'Cette action est définitive. Voulez-vous continuer ?'}</p>
        <div className="admin-confirm-actions"><button type="button" className="admin-button admin-button-light" onClick={onCancel}>Annuler</button><button type="button" className="admin-button admin-confirm-delete" onClick={onConfirm}><i className="fa fa-trash" aria-hidden="true" /> {confirmLabel}</button></div>
      </div>
    </div>
  );
};

export default AdminConfirmModal;
